// extracted by mini-css-extract-plugin
export default {"home":"home_home__qA4gR","container":"home_container__5wttX","shorcuts":"home_shorcuts__aGeXs","titleEntity":"home_titleEntity__LIi9y"};